// @ts-ignore
import $ from "jquery";

const mobileMaximumViewportWidth = 992;
const mobileArrowActiveClassName = "btn-arrow-mobile-active";
const mobileArrowActiveFallbackTimeoutMilliseconds = 1200;

export default function setupSlickArrowMobileFeedback(carouselElement: HTMLDivElement | null, previousButton: HTMLButtonElement | null, nextButton: HTMLButtonElement | null) {
  if (!carouselElement || !previousButton || !nextButton) {
    return;
  }

  let activeArrowButton: HTMLButtonElement | null = null;
  let fallbackTimeoutIdentifier: number | null = null;

  const isMobileViewport = () => window.innerWidth <= mobileMaximumViewportWidth;

  const clearArrowActiveState = () => {
    if (activeArrowButton) {
      activeArrowButton.classList.remove(mobileArrowActiveClassName);
      activeArrowButton = null;
    }

    if (fallbackTimeoutIdentifier !== null) {
      window.clearTimeout(fallbackTimeoutIdentifier);
      fallbackTimeoutIdentifier = null;
    }
  };

  const applyArrowActiveState = (arrowButton: HTMLButtonElement | null) => {
    if (!arrowButton || !isMobileViewport() || !arrowButton.classList.contains("btn-arrow")) {
      return;
    }

    if (arrowButton.classList.contains("slick-disabled")) {
      return;
    }

    clearArrowActiveState();

    activeArrowButton = arrowButton;
    activeArrowButton.classList.add(mobileArrowActiveClassName);

    fallbackTimeoutIdentifier = window.setTimeout(() => {
      clearArrowActiveState();
    }, mobileArrowActiveFallbackTimeoutMilliseconds);
  };

  const handleArrowButtonClick = (event: Event) => {
    const clickedArrowButton = event.currentTarget as HTMLButtonElement | null;
    applyArrowActiveState(clickedArrowButton);
  };

  previousButton.addEventListener("click", handleArrowButtonClick, { capture: true });
  nextButton.addEventListener("click", handleArrowButtonClick, { capture: true });

  $(carouselElement).on("afterChange", () => {
    clearArrowActiveState();
  });
}
